import React, { useState } from 'react'
import { FaChevronDown, FaQuestion } from 'react-icons/fa6'
import Header from './Header'
import Bottom from './Bottom'

function FAQs() {

  const [fst, setfst] = useState(false)
  const [sec, setsec] = useState(false)
  const [trd, settrd] = useState(false)
  const [frt, setfrt] = useState(false)
  const [fif, setfif] = useState(false)
  const [six, setsix] = useState(false)
  const [sev, setsev] = useState(false)
  const [eit, seteit] = useState(false)
  const [nin, setnin] = useState(false)
  const [ten, setten] = useState(false)

  const fstClick=()=>{
    fst ? setfst(false) : setfst(true)
    setsec(false)
    settrd(false)
    setfrt(false)
    setfif(false)
    setsix(false)
    setsev(false)
    seteit(false)
    setnin(false)
    setten(false)
  }

  const secClick=()=>{
    sec ? setsec(false) : setsec(true)
    setfst(false)
    settrd(false)
    setfrt(false)
    setfif(false)
    setsix(false)
    setsev(false)
    seteit(false)
    setnin(false)
    setten(false)
  }

  const trdClick=()=>{
    trd ? settrd(false) : settrd(true)
    setsec(false)
    setfst(false)
    setfrt(false)
    setfif(false)
    setsix(false)
    setsev(false)
    seteit(false)
    setnin(false)
    setten(false)
  }

  const frtClick=()=>{
    frt ? setfrt(false) : setfrt(true)
    setsec(false)
    settrd(false)
    setfst(false)
    setfif(false)
    setsix(false)
    setsev(false)
    seteit(false)
    setnin(false)
    setten(false)
  }

  const fifClick=()=>{
    fif ? setfif(false) : setfif(true)
    setsec(false)
    settrd(false)
    setfrt(false)
    setfst(false)
    setsix(false)
    setsev(false)
    seteit(false)
    setnin(false)
    setten(false)
  }

  const sixClick=()=>{
    six ? setsix(false) : setsix(true)
    setsec(false)
    settrd(false)
    setfrt(false)
    setfif(false)
    setfst(false)
    setsev(false)
    seteit(false)
    setnin(false)
    setten(false)
  }

  const sevClick=()=>{
    sev ? setsev(false) : setsev(true)
    setsec(false)
    settrd(false)
    setfrt(false)
    setfif(false)
    setsix(false)
    setfst(false)
    seteit(false)
    setnin(false)
    setten(false)
  }

  const eitClick=()=>{
    eit ? seteit(false) : seteit(true)
    setsec(false)
    settrd(false)
    setfrt(false)
    setfif(false)
    setsix(false)
    setsev(false)
    setfst(false)
    setnin(false)
    setten(false)
  }

  const ninClick=()=>{
    nin ? setnin(false) : setnin(true)
    setsec(false)
    settrd(false)
    setfrt(false)
    setfif(false)
    setsix(false)
    setsev(false)
    seteit(false)
    setfst(false)
    setten(false)
  }

  const tenClick=()=>{
    ten ? setten(false) : setten(true)
    setsec(false)
    settrd(false)
    setfrt(false)
    setfif(false)
    setsix(false)
    setsev(false)
    seteit(false)
    setnin(false)
    setfst(false)
  }


  return (
    <div className='home' >
        <Header/>

        <div className='faqs_banner' >
          <div className='faqs_design' ></div>
          <h1>FREQUENTLY ASKED QUESTIONS (FAQs) </h1>
          <div className='faqs_ball_' >
            <FaQuestion size={200} color='#fff' />
          </div>
        </div>

        <div className='faqs_list' >
          <div className='faqs_5list' >
            <div className='faqs_list_' >
              <div onClick={()=>fstClick()} >
                <h3>What Services do you offer ?</h3>
                <FaChevronDown/>
              </div>

              {
                fst ?
                <p>
                  We offer same-day delivery, next-day delivery, scheduled deliveries, and express courier services for both domestic and international shipments.
                </p> 
                : null
              }
            </div>

            <div className='faqs_list_' >
              <div onClick={()=>secClick()}>
                <h3>How do I book a courier ?</h3>
                <FaChevronDown/>
              </div>

              {
                sec ?
                <p>
                  You can book a courier through our website, mobile app, or by calling our customer service line.
                </p>
                : null
              }
            </div>
            
            <div className='faqs_list_' >
              <div onClick={()=>trdClick()} >
                <h3>What areas do you cover ?</h3>
                <FaChevronDown/>
              </div>

              {
                trd ?
                <p>
                  We provide services across the globe, with international shipping available for all countries.
                </p>
                : null
              }
            </div>

            <div className='faqs_list_' >
              <div onClick={()=> frtClick()} >
                <h3>How do I track my shipment ?</h3>
                <FaChevronDown/>
              </div>

              {
                frt ?
                <p>
                  Once your package is booked, you will receive a tracking number. You can use this number on our website or app to see real-time updates on your delivery.
                </p>
                : null
              }
            </div>

            <div className='faqs_list_' >
              <div onClick={()=>fifClick()} >
                <h3>What can’t I send via your courier service ?</h3>
                <FaChevronDown/>
              </div>

              {
                fif ?
                <p>
                  We do not transport hazardous materials, illegal items, perishable food, or high-value items like cash or jewelry. Please see our restricted items list for details.
                </p>
                : null
              }
            </div>
          </div>

          <div className='faqs_5list' >
            <div className='faqs_list_' >
              <div onClick={()=>sixClick()} >
                <h3>What happens if I miss the delivery ?</h3>
                <FaChevronDown/>
              </div>

              {
                six ?
                <p>
                  Our courier will attempt delivery again or leave a note with instructions to reschedule. You may also pick up your parcel from a nearby hub.
                </p>
                : null
              }
            </div>

            <div className='faqs_list_' >
              <div onClick={()=>sevClick()} >
                <h3>Can I change the delivery address after booking ?</h3>
                <FaChevronDown/>
              </div>

              {
                sev ?
                <p>
                  Yes, you can request a change before the item is out for delivery. Contact our support team as soon as possible.
                </p>
                : null
              }
            </div>
            
            <div className='faqs_list_' >
              <div onClick={()=>eitClick()} >
                <h3> What should I do if my package is lost or damaged ?</h3>
                <FaChevronDown/>
              </div>

              {
                eit ?
                <p>
                  Please contact our support team immediately. We will investigate and, if eligible, initiate a compensation process in accordance with our insurance policy.
                </p>
                : null
              }
            </div>

            <div className='faqs_list_' >
              <div onClick={()=> ninClick()} >
                <h3>Do you offer bulk shipping or business accounts ?</h3>
                <FaChevronDown/>
              </div>

              {
                nin ?
                <p>
                  Yes, we offer customized solutions for businesses including bulk deliveries, scheduled pickups, and discounted rates for frequent shipping.
                </p>
                : null
              }
            </div>

            <div className='faqs_list_' >
              <div onClick={()=> tenClick()} >
                <h3>How are your shipping rates calculated ?</h3>
                <FaChevronDown/>
              </div>

              {
                ten ?
                <p>
                  Shipping rates depend on the weight, size, delivery speed, and destination of the package. You can use our online quote tool for an estimate.
                </p>
                : null
              }
            </div>
          </div>
        </div>

        <Bottom/>
    </div>
  )
}

export default FAQs